import { useEffect, useRef, useState } from "react"
import "./tableActionsComponent.scss"
import MoreCircleSVG from "../SVG/MoreCircleSVG";
import ReactDOM from "react-dom";

interface IActions {
  label?: string;
  onClick?: () => void;
  style?: string;
  component?: JSX.Element
  inVisible?: boolean,
}
export default function TableActionsComponent({ actions }: { actions: Array<IActions> }) {
  const [showActions, setShowActions] = useState(false)
  const [coord, setCoord] = useState({
    x: 0,
    y: 0
  })

  return (
    <div className="table-action-component-wrapper w-full h-full flex justify-center items-center">
      <div className="table-action-component w-auto  h-auto flex justify-center items-center">
        <span
          onClick={(event) => {
            setShowActions(!showActions);
            setCoord((prev) => ({
              ...prev,
              x: event.clientX,
              y: event.clientY
            }));
          }}
        >
          <MoreCircleSVG className={`cursor-pointer hover:fill-slate-200 ${showActions && "fill-slate-200"}`} />
        </span>
        {
          showActions &&
          (
            <CustomCTXMenu
              showActions={showActions}
              actions={actions}
              setShowActions={setShowActions}
              x={coord.x}
              y={coord.y}
            />
          )
        }
      </div>
    </div>
  )
}


function useClickOutside(ref, func) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        func()
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
}

const CustomCTXMenu = ({ showActions, setShowActions, actions, x, y }) => {
  const menuBody = useRef(null);
  useClickOutside(menuBody, () => setShowActions(false));
  return ReactDOM.createPortal (
    <>
      <div
        ref={menuBody}
        style={{
          top: y,
          left: x - 200
        }}
        className="absolute flex flex-col gap-2 justify-center items-center p-2 rounded-md bg-white shadow-md z-50 min-w-40 w-fit"
      >
        {
          actions.map((singleAction, index) => {
            if (singleAction.inVisible) return ''
            if (singleAction.component) {
              return (singleAction.component)
            } else {
              return (
                <button key={index} type='button' className={`h-8 flex justify-center items-center !rounded-full bg-az-light-red text-az-teal !w-full ${singleAction.style}`}
                  onClick={() => {
                    singleAction.onClick && singleAction.onClick();
                    setShowActions(!showActions)
                  }}>
                  <p>{singleAction.label}</p>
                </button>
              )
            }
          })
        }
      </div>
    </>,
    document.getElementById('portal')!
  )
}
